<template>
  <div class="flex items-center" :class="{ 'pointer-events-none opacity-50' : disabled }">
    <div
      class="relative rounded-full transition duration-200 ease-linear"
      :class="[
        isChecked ? `bg-${checkedColour}` : `bg-${uncheckedColour} dark:bg-gray-700`,
        { 'w-12 h-6': size === 'md' },
        { 'w-6 h-3': size === 'xs' },
      ]"
    >
      <label
        :for="id"
        class="absolute left-0 bg-white dark:bg-gray-800  mb-2 rounded-full transition transform duration-100 ease-linear cursor-pointer"
        :class="[
          isChecked ? ['translate-x-full', `border-${checkedColour}`] : ['translate-x-0', `border-${uncheckedColour} dark:border-gray-700`],
          { 'w-6 h-6 border-2': size === 'md' },
          { 'w-3 h-3 border': size === 'xs' },
        ]"
      />
      <input
        :id="id"
        v-model="_model"
        :value="value"
        :true-value="value"
        :false-value="uncheckedValue"
        type="checkbox"
        name="toggle"
        class="appearance-none w-full h-full active:outline-none focus:outline-none"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue'

interface Props {
  value?: string | Record<string, any> | number | boolean | any[] | null
  uncheckedValue?: string | Record<string, any> | number | boolean | any[] | null
  modelValue?: string | Record<string, any> | number | boolean | any[] | null
  checkedColour?: string
  uncheckedColour?: string
  disabled?: boolean
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  value: true,
  uncheckedValue: false,
  modelValue: null,
  checkedColour: 'primary-500',
  uncheckedColour: 'gray-300',
  disabled: false,
  size: 'md',
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
  (e: 'change', value: any): void
}>()

const id = getCurrentInstance()?.uid

const _model = computed({
  get () {
    return props.modelValue
  },
  set (model: any) {
    emit('update:modelValue', model)
    emit('change', model)
  },
})

const isArray = computed(() => {
  return Array.isArray(props.modelValue)
})

const isChecked = computed(() => {
  if (isArray.value) {
    return (_model.value as any[]).includes(props.value)
  }

  return _model.value === props.value
})
</script>
